import { useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ToastContext } from 'cat-ecommerce-alloy';
import { STATUS } from '../../../../../../../constants/commonConstants';
import LoadingToast from '../../toasts/LoadingToast';
import ErrorToast from '../../toasts/ErrorToast';
import SuccessToast from '../../toasts/SuccessToast';
import { setOrdersToIdle } from '../../../../../../../store/orders/actions';

const useOrderUpdateToasts = () => {
  const toastCtx = useContext(ToastContext);
  const dispatch = useDispatch();
  const ascendingOrderItems = useSelector(
    s => s.orders.byId[s.orders.current]?.ascendingOrderItems || []
  );
  const { updatingStatus, isOrderSubtotalLoading } = useSelector(s => s.orders);

  useEffect(() => {
    const itemsWithServerErrors = ascendingOrderItems.filter(
      item => item.hasItemHadServerError
    );

    let areAnyItemsLoading = false;
    let doCurrentItemsHaveErrors = false;

    itemsWithServerErrors.forEach(item => {
      if (item.isUpdateLineItemLoading) {
        areAnyItemsLoading = true;
      }
      if (item.errors.server) {
        doCurrentItemsHaveErrors = true;
      }
    });

    if (itemsWithServerErrors.length) {
      switch (updatingStatus) {
        case STATUS.PENDING:
          toastCtx.destroyAllToasts();
          toastCtx.createWarningToast(<LoadingToast />, Infinity, true);
          break;
        case STATUS.REJECTED:
          if (!areAnyItemsLoading && doCurrentItemsHaveErrors) {
            toastCtx.destroyAllToasts();
            toastCtx.createErrorToast(<ErrorToast />, Infinity, true);
          }
          break;
        case STATUS.RESOLVED:
          if (doCurrentItemsHaveErrors) {
            toastCtx.destroyAllToasts();
            toastCtx.createErrorToast(<ErrorToast />, Infinity, true);
          }
          break;
        default: //do nothing
      }
    } else if (updatingStatus === STATUS.RESOLVED && !isOrderSubtotalLoading) {
      toastCtx.destroyAllToasts();
      toastCtx.createSuccessToast(<SuccessToast />);
      dispatch(setOrdersToIdle());
    }
    // toastCtx is unstable
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOrderSubtotalLoading, updatingStatus, ascendingOrderItems, dispatch]);
};

export default useOrderUpdateToasts;
